// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

// Define a service using a base URL and expected endpoints
export const productsApi = createApi({
    reducerPath: "productsApi",
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.REACT_APP_PRODUCT_BASE_URL,
        prepareHeaders: (headers, { getState }) => {
            headers.set('Access-Control-Allow-Origin', '*')
            headers.set('tempusername', 'test')
            return headers
        }
    },),
    // refetchOnMountOrArgChange: true,
    // refetchOnFocus: true,
    tagTypes: ['Product', 'Cart', 'AllProduct'],
    endpoints: (builder) => ({
        AllProducts: builder.query({
            query: () => `products/get`,
            providesTags: ['AllProduct'],
        }),
        CategoryProducts: builder.query({
            query: ({ id, offset }) => `/products/get?limit=20&categoryId=${id}&offset=${offset}`,
            providesTags: ['Product'],
        }),
        getCart: builder.query({
            query: (tempid) => `cart/get?tempID=${tempid}`,
            providesTags: ['Cart'],
        }),
        addCart: builder.mutation({
            query: cart => ({
                url: 'cart/add',
                method: 'POST',
                body: cart
            }),
            invalidatesTags: ['Cart'],
            // async onQueryStarted(_, { dispatch, queryFulfilled }) {
            //     try {
            //         const res = await queryFulfilled;
            //         console.log('reas',res);
            //         // setTimeout(() => {
            //             dispatch(
            //                 productsApi.util.updateQueryData('AllProducts', undefined, (products) => {
            //                     // console.log('resdata',products.data);
                                
            //                     let project = products?.find((item) => item?.item_id === 8873);
            //                     console.log('resdata',project);
            //                 }),
            //             );
            //         // }, 10000);
            //     } catch (e) {
            //         console.error(e);
            //     }
            // },
        }),
    }),

});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useAllProductsQuery, useCategoryProductsQuery, useGetCartQuery, useAddCartMutation } = productsApi;
